import styled from '@emotion/styled';
import { FC, PropsWithChildren } from 'react';

import Box, { BoxProps } from '../components/Box';
import { useDidMount } from '../hooks';

// Local Typings
interface WrapperProps extends Omit<BoxProps, 'className' | 'opacity' | 'transition'> {
  isIn: boolean;
  shouldMountWithoutFade?: boolean;
  transitionSpeedInMs?: number;
}
interface Props extends WrapperProps {
  containerProps?: BoxProps;
}

// Local Variables
const fadeClassName = 'fade-is-in';
const Wrapper = styled(Box)<WrapperProps>(({ transitionSpeedInMs }) => ({
  [`&.${fadeClassName}`]: {
    opacity: 1,
  },
  opacity: 0,
  transition: `${transitionSpeedInMs}ms`,
}));

// Component Definition
const Fade: FC<PropsWithChildren<Props>> = ({
  children,
  containerProps,
  isIn,
  shouldMountWithoutFade = false,
  transitionSpeedInMs = 1000,
  ...boxProps
}) => {
  const didMount = useDidMount();
  const isVisible = didMount && isIn;

  return (
    <Box {...containerProps}>
      <Wrapper
        {...boxProps}
        className={isVisible ? fadeClassName : undefined}
        isIn={shouldMountWithoutFade || isVisible}
        transitionSpeedInMs={transitionSpeedInMs}
      >
        {children}
      </Wrapper>
    </Box>
  );
};

export default Fade;
